module.exports = __webpack_public_path__ + "img/3-2.902b8d36.svg";